import {EQLGame, Frontend} from './eql'

//const momentumSDK = '/momentum-sdk-2.0.6-alpha.6.js';
//import '../vendor/momentum-sdk-2.0.6-alpha.6.js?raw';

var momentumBus:any = null;

function getClientInfoAsync(bus: any, opts: object = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      bus.getClientInfo(
        opts,
        (data: any, err?: any) => (err ? reject(err) : resolve(data))
      );
    });
}

function geoValidateAsyn(bus: any, opts: object = {}): Promise<any> {
    return new Promise((resolve, reject) => {
      bus.geoValidate(
        opts,
        (data: any, err?: any) => (err ? reject(err) : resolve(data))
      );
    });
}

export default class Momentum implements Frontend {
    code: string = "MOMENTUM";

    PreLaunch = async (game: EQLGame): Promise<EQLGame> => {  
        // TODO: have them fix the CORS error
        //await import(/* webpackIgnore: true */ momentumSDK);

        game.STATE.extraData = 'eyJ2ZXJzaW9uIjogIjEuMC4wIiwgInZlcnNpb25Db2RlIjogIjEwMCIsICJwcm9kdWN0IjogIjYwMyIsICJwbGF0Zm9ybSI6ICI3In0=';
    
        momentumBus = new (window as any).$AppSDK.bus({
            os: 3,
            platform: "nl",
            api: "",
        });
        
        if (momentumBus && game.GetPlayMode()==="M") {
            try {
                const responseData = await getClientInfoAsync(momentumBus);
                game.STATE.extraData = responseData.data;
            } catch (err) {
                console.error("getClientInfo failed:", err);
            }
        }
        
        return game; 
    }

    PreWager = async (game: EQLGame): Promise<EQLGame> => {  
        if (momentumBus && game.GetPlayMode()==="M") {
            try {
                const responseData = await geoValidateAsyn(momentumBus);
                game.STATE.extraData = responseData.data;
            } catch (err) {
                console.error("getLocationinfo failed:", err);
            }
        }
        
        return game; 
    }

    SendClientEvent = (eventName: string, gameId: string|null, languageCode: string, data?: any) => {
    }

    ApplyLaunchParams = (game: EQLGame):EQLGame => {
        return game
    }
}